// ChartCard.jsx
import React, { useState } from "react";
import { Card, Radio } from "antd";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import moment from "moment";
import { useSelector } from "react-redux";

const ChartCardlogin = ({
  title,
  dataKey,
  color,
  selected,
  onClick,
  colornumber,
}) => {
  const [view, setView] = useState("weekly");
  const [date, setDate] = useState(moment().format("YYYY-MM-DD"));

  const allcampaign = useSelector((state) => state?.campaignReducer?.Allcampaign);

  const dataYearly = allcampaign?.isLoginTrue?.yearly || [];
  const dataMonthly = allcampaign?.isLoginTrue?.monthly || [];
  const dataWeekly = allcampaign?.isLoginTrue?.weekly || [];
  const dataDaily = allcampaign?.isLoginTrue?.daily || [];

  const handleViewChange = (e) => {
    setView(e.target.value);
  };

  const handleDateChange = (e) => {
    setDate(e.target.value);
  };

  const getData = () => {
    switch (view) {
      case "yearly":
        return dataYearly;
      case "monthly":
        return dataMonthly;
      case "weekly":
        return dataWeekly;
      case "daily":
        return dataDaily;
      default:
        return dataWeekly;
    }
  };

  const chartData = getData();

  return (
    <Card
      title={title}
      bordered={false}
      // extra={
      //   <input
      //     className="calender"
      //     onChange={handleDateChange}
      //     value={date}
      //     type="date"
      //   />
      // }
      className={`chart-card ${selected ? "selected" : ""}`}
      onClick={onClick}
    >
      <Radio.Group value={view} onChange={handleViewChange} style={{ marginBottom: 16 }}>
        <Radio.Button value="yearly">Yearly</Radio.Button>
        <Radio.Button value="monthly">Monthly</Radio.Button>
        <Radio.Button value="weekly">Weekly</Radio.Button>
        <Radio.Button value="daily">Daily</Radio.Button>
      </Radio.Group>
      {chartData.length > 0 ? (
        <ResponsiveContainer width="100%" height={300}>
          <LineChart width={474} height={386} data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line
              type="monotone"
              dataKey={dataKey}
              stroke={color}
              strokeWidth={2}
              activeDot={{ r: 8 }}
            />
          </LineChart>
        </ResponsiveContainer>
      ) : (
        <div style={{ textAlign: "center", padding: "20px", fontSize: "18px", fontWeight: "bold", color: "#888" }}>
          No records found
        </div>
      )}
      <div className="d-flex">
        <p
          className={`chart-card ${
            colornumber === 0 ? "redbox" : colornumber === 1 ? "greenbox" : "nobox"
          }`}
        ></p>
        <p className="boxpara">User Who Clicked</p>
      </div>
    </Card>
  );
};

export default ChartCardlogin;
